import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import RateSetWizard from '../../generic-components/add-rates-wizard/add-rateset-wizard.jsx';

const AddRateSet = ({
  onRequestClose,
  productName,
  usedRateSetNamesAndCodes,
  productType,
  onFinish,
  getOverlappingDaysError,
  openGlobalAlert,
}) => {
  return (
    <RateSetWizard
      cancelText="Cancel"
      productName={productName}
      usedRateSetNamesAndCodes={usedRateSetNamesAndCodes}
      getOverlappingDaysError={getOverlappingDaysError}
      onFinish={onFinish}
      cancelFunc={() => {
        openGlobalAlert({
          text: 'You will lose all the data you just entered if you cancel now. Are you sure you want to cancel?',
          onOk: onRequestClose,
        });
      }}
      showStepOneBack={false}
      step3ContinueText="add rate set"
      productType={productType}
    />
  );
};

AddRateSet.propTypes = {
  onRequestClose: PropTypes.func,
  data: PropTypes.object,
  onTextFieldChangeWithKeyPath: PropTypes.func,
  productType: PropTypes.string,
  productName: PropTypes.string,
  clearWizard: PropTypes.func,
  getOverlappingDaysError: PropTypes.func,
};

const mapActions = ({
  clearWizard: () => ({ type: 'CLEAR_ADD_RATE_SET_WIZARD' }),
  openGlobalAlert: payload => ({
    type: 'open_global_alert',
    payload,
  }),
});
export default connect(null, mapActions)(AddRateSet);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/add-rate-set.jsx